import { render, staticRenderFns } from "./Shopify.vue?vue&type=template&id=707f39fd&"
import script from "./Shopify.vue?vue&type=script&lang=ts&"
export * from "./Shopify.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports